import { Action } from '../decorator/log';
import Base from './BaseStore';
class CommonStore extends Base {
    state = {
        isLoad: false,
        count: 1
    };

    @Action changeLoad() {
        this.state.isLoad = true;
        return this.state;
    }

    @Action
    async changeAge() {
        try {
            this.state.count++;
            await this.$api({
                path: '/api',
                method: 'post',
                params: {
                    name: 'jack',
                    value: [1, 2, 3, 4],
                    data: {
                        my: 'jack',
                        your: 'ruby'
                    }
                }
            });
        } catch (error) {
            console.log(error);
        }
        return this.state;
    }
}
export default new CommonStore();
